/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './gynic-history.reducer';

export const GynicHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const gynicHistoryEntity = useAppSelector(state => state.gynicHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="gynicHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.gynicHistory.detail.title">GynicHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{gynicHistoryEntity.id}</dd>
          <dt>
            <span id="menarche">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.menarche">Menarche</Translate>
            </span>
          </dt>
          <dd>{gynicHistoryEntity.menarche}</dd>
          <dt>
            <span id="cycleStart">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.cycleStart">Cycle Start</Translate>
            </span>
          </dt>
          <dd>{gynicHistoryEntity.cycleStart}</dd>
          <dt>
            <span id="cycleEnd">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.cycleEnd">Cycle End</Translate>
            </span>
          </dt>
          <dd>{gynicHistoryEntity.cycleEnd}</dd>
          <dt>
            <span id="loss">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.loss">Loss</Translate>
            </span>
          </dt>
          <dd>{gynicHistoryEntity.loss}</dd>
          <dt>
            <span id="interMenstrualBleed">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.interMenstrualBleed">Inter Menstrual Bleed</Translate>
            </span>
          </dt>
          <dd>{gynicHistoryEntity.interMenstrualBleed}</dd>
          <dt>
            <span id="pain">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.pain">Pain</Translate>
            </span>
          </dt>
          <dd>{gynicHistoryEntity.pain}</dd>
          <dt>
            <span id="vaginalDischarge">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.vaginalDischarge">Vaginal Discharge</Translate>
            </span>
          </dt>
          <dd>{gynicHistoryEntity.vaginalDischarge}</dd>
          <dt>
            <span id="papSmear">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.papSmear">Pap Smear</Translate>
            </span>
          </dt>
          <dd>{gynicHistoryEntity.papSmear}</dd>
          <dt>
            <span id="contraception">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.contraception">Contraception</Translate>
            </span>
          </dt>
          <dd>{gynicHistoryEntity.contraception ? 'true' : 'false'}</dd>
          <dt>
            <span id="contraceptionDetails">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.contraceptionDetails">Contraception Details</Translate>
            </span>
          </dt>
          <dd>{gynicHistoryEntity.contraceptionDetails}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{gynicHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{gynicHistoryEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{gynicHistoryEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{gynicHistoryEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.gynicHistory.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{gynicHistoryEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.gynicHistory.patient">Patient</Translate>
          </dt>
          <dd>{gynicHistoryEntity.patient ? gynicHistoryEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/gynic-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/gynic-history/${gynicHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default GynicHistoryDetail;
